module.exports = __webpack_public_path__ + "img/secretCoupon01.17df1cc7.jpg";